//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TalksMap from "@/utils/initMapTalks.js";
import MapLandInfoVertical from "@/components/LandMap/MapLandInfoVertical";
import MapLandInfoHorizontal from "@/components/LandMap/MapLandInfoHorizontal";
import { log } from "util";
export default {
  components: {
    MapLandInfoVertical,
    MapLandInfoHorizontal,
  },
  data() {
    return {
      TalksMapDialog: new TalksMap(),
      landList: [], // 所有的地块
      landTotalInfo: {}, // 地块总的信息
      showRightInfo: false,
      curLandInfo: {}, // 选中地块信息
      mapHasHover: false,
      mapHasSelected: false,
      coordinate: [116.177427669, 28.861500052],
    };
  },
  props: {
    contractId: {
      type: String,
    },
    contractType: {
      type: String,
    },
  },
  watch: {
    landList: {
      handler: function (n) {
        // this.TalksMapDialog.land(
        //   this.landList,
        //   "croplandEdge",
        //   "",
        //   this.mapHasHover,
        //   this.mapHasSelected
        // );
        let lng, lat;
        if (this.landList.length == 0) {
          lng = 116.177427669;
          lat = 28.861500052;
        } else {
          let temp = JSON.parse(this.landList[0].centroid).coordinates;
          lng = temp[0];
          lat = temp[1];
        }
        let Coordinate = {
          x: lng,
          y: lat,
        };
        this.coordinate = Coordinate;
        this.TalksMapDialog.land(
          this.landList,
          "croplandEdge",
          this.landCallBack,
          this.mapHasHover,
          this.mapHasSelected
        );
      },
    },
  },
  mounted() {
    this.TalksMapDialog.sendThis(this);
    this.getMapInit();
    this.getLandList({ contractId: this.contractId });
  },
  methods: {
    /**
     * @Description:
     * @Author: yangsibo
     * @Date: 2022-12-29 09:12:20
     * @return {*}
     */
    initialAddress() {
      this.TalksMapDialog.map.setCenter(this.coordinate);
    },
    /**
     * @descripttion: 获取地块信息
     * @Author: juanjuanhui
     * @Date: 2021-12-02 20:30:34
     */
    getLandList(params) {
      this.$http.contract.getContractDetailLands(params).then((res) => {
        let { contractLandProtocols, ...data } = res.data;
        this.landTotalInfo = data;
        if (contractLandProtocols && contractLandProtocols.length > 0) {
          this.landList = contractLandProtocols;
        }
      });
    },
    /**
     * @descripttion: 地图初始化
     * @Author: juanjuanhui
     * @Date: 2021-12-02 20:40:39
     */
    getMapInit() {
      this.TalksMapDialog.init("mapDiv", 16);
    },
    /**
     * @descripttion: 绘制地块的回调函数
     * @Author: juanjuanhui
     * @Date: 2021-12-02 21:02:49
     */
    landCallBack(e) {
      this.curLandInfo = {};
      let target = e.target;
      this.showRightInfo = true;
      this.getLandDetail(target.val.id);
    },
    /**
     * @descripttion: 获取地块详细信息
     * @Author: juanjuanhui
     * @Date: 2022-03-14 21:22:15
     * @param {*} id
     */
    getLandDetail(id) {
      this.$http.work.getLandDetail({ id }).then((res) => {
        this.curLandInfo = res.data;
      });
    },
    /**
     * @descripttion: 关闭地图右侧信息
     * @Author: juanjuanhui
     * @Date: 2022-03-10 20:17:50
     */
    handleChangeRightInfo() {
      this.showRightInfo = false;
    },
  },
};
